import { useContext } from "react";
import { EventCreationContext } from "../../../event_creation";

export function useEventCreationContext() {
	return useContext(EventCreationContext);
}
